export default __webpack_public_path__ + "static/media/home.e6951eb4.png";